import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from './api';
import { Box, Container, CssBaseline, Typography, Button, TextField } from '@mui/material';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const handleReset = async () => {
    try {
      if (!token) {
        setMessage('再設定リンクが無効です。もう一度再設定を依頼してください。');
        return;
      }
      const res = await api.post('/api/reset-password', {
        token,
        new_password: newPassword,
      });

      if (res.status === 200) {
        setMessage('パスワードを更新しました。ログイン画面へ遷移します...');
        setTimeout(() => {
          navigate("/"); // ← ログインページへ遷移
        }, 2000);
      }
    } catch (err) {
      console.error(err);
      setMessage('パスワードの更新に失敗しました');
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: "url('/login-bg.png')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        py: 4,
      }}
    >
      <Container component="main" maxWidth="100%" sx={{ minHeight: '80vh' }}>
        <CssBaseline />
        <Box sx={{ display: 'flex' }}>
          <Box sx={{padding: 5 , textAlign: 'right' }}>
            <img src="/logo.png" alt="logo" style={{ width: '60%' }}/>
            <Typography>メッセナゴヤ<br />出展者申請システム</Typography>
          </Box>
          <div style={{ padding: '2rem' }}>
            <h2>パスワード再設定</h2>
            <TextField
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="新しいパスワード"
              fullWidth
              sx={{ mb: 2 }}
            />
            <Button variant="contained" onClick={handleReset} fullWidth disabled={!token}>更新</Button>
            <p>{message}</p>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPassword;
